// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__eaG5C","label":"Labeled_label__3KnvZ","divider":"Labeled_divider__1uwoC"};